import { Badge } from "./ui/badge";

const STATUS = {
  todo: { label: "To Do", cls: "bg-slate-500/15 text-slate-500 dark:text-slate-400 border-slate-500/30" },
  in_progress: { label: "In Progress", cls: "bg-blue-500/15 text-blue-600 dark:text-blue-400 border-blue-500/30" },
  blocked: { label: "Blocked", cls: "bg-rose-500/15 text-rose-600 dark:text-rose-400 border-rose-500/30" },
  testing: { label: "Testing", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30" },
  completed: { label: "Completed", cls: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30" },
  draft: { label: "Draft", cls: "bg-slate-500/15 text-slate-500 dark:text-slate-400 border-slate-500/30" },
  in_review: { label: "In Review", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30" },
  approved: { label: "Approved", cls: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30" },
  open: { label: "Open", cls: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30" },
  closed: { label: "Closed", cls: "bg-purple-500/15 text-purple-600 dark:text-purple-400 border-purple-500/30" },
  needed: { label: "Needed", cls: "bg-slate-500/15 text-slate-500 dark:text-slate-400 border-slate-500/30" },
  ordered: { label: "Ordered", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30" },
  received: { label: "Received", cls: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30" },
  active: { label: "Active", cls: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30" },
  planning: { label: "Planning", cls: "bg-blue-500/15 text-blue-600 dark:text-blue-400 border-blue-500/30" },
  on_hold: { label: "On Hold", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30" },
  archived: { label: "Archived", cls: "bg-slate-500/15 text-slate-500 border-slate-500/30" },
};

const PRIORITY = {
  P0: "bg-rose-500/15 text-rose-600 dark:text-rose-400 border-rose-500/30",
  P1: "bg-orange-500/15 text-orange-600 dark:text-orange-400 border-orange-500/30",
  P2: "bg-blue-500/15 text-blue-600 dark:text-blue-400 border-blue-500/30",
  P3: "bg-slate-500/15 text-slate-500 dark:text-slate-400 border-slate-500/30",
};

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || { label: status, cls: "" };
  return <Badge variant="outline" className={`text-[10px] font-mono uppercase tracking-wider ${s.cls}`}>{s.label}</Badge>;
};

export const PriorityBadge = ({ priority }) => (
  <Badge variant="outline" className={`text-[10px] font-mono ${PRIORITY[priority] || PRIORITY.P3}`}>{priority}</Badge>
);

const LABEL_COLORS = {
  bug: "bg-rose-500/15 text-rose-600 dark:text-rose-400 border-rose-500/30",
  frontend: "bg-cyan-500/15 text-cyan-600 dark:text-cyan-400 border-cyan-500/30",
  firmware: "bg-indigo-500/15 text-indigo-600 dark:text-indigo-400 border-indigo-500/30",
  "ml-model": "bg-fuchsia-500/15 text-fuchsia-600 dark:text-fuchsia-400 border-fuchsia-500/30",
  hardware: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30",
  sdk: "bg-teal-500/15 text-teal-600 dark:text-teal-400 border-teal-500/30",
  process: "bg-violet-500/15 text-violet-600 dark:text-violet-400 border-violet-500/30",
  "lab-ops": "bg-lime-600/15 text-lime-700 dark:text-lime-400 border-lime-500/30",
};

export const LabelBadge = ({ label }) => (
  <Badge variant="outline" className={`text-[10px] font-mono ${LABEL_COLORS[label] || "bg-slate-500/15 text-slate-500 border-slate-500/30"}`}>
    #{label}
  </Badge>
);

export const Avatar = ({ name, size = "sm" }) => {
  const initials = (name || "?").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
  const colors = ["bg-blue-600", "bg-emerald-600", "bg-amber-600", "bg-rose-600", "bg-indigo-600", "bg-teal-600"];
  const c = colors[(name || "").length % colors.length];
  const sz = size === "xs" ? "h-5 w-5 text-[9px]" : size === "md" ? "h-8 w-8 text-xs" : "h-6 w-6 text-[10px]";
  return (
    <span className={`inline-flex items-center justify-center rounded-full text-white font-semibold shrink-0 ${c} ${sz}`} title={name}>
      {initials}
    </span>
  );
};
